<div class="filters-box">
  <div class="filters-box__header" (click)="setIsBoxOpened()">
    <!-- box header -->
    <div class="box-title">
      <!-- box icon -->
      <span class="box-title__icon">
        <i class="iconsax" [attr.icon-name]="boxIcon()"></i>
      </span>
      <!-- box title -->
      <h3 class="box-title__text">
        {{ boxTitle() | translate }}
      </h3>
    </div>

    <!-- box toggle btn -->
    @if (isClosableBox()) {
      <button class="box-toggle-btn">
        <i
          class="iconsax"
          [attr.icon-name]="isBoxOpened ? 'chevron-up' : 'chevron-down'"></i>
      </button>
    }
  </div>

  <!-- nested filters -->
  @if (isBoxOpened) {
    <form [formGroup]="nestedFiltersForm">
      <ul class="filters-box__body custom-scrollbar">
        <!-- checkboxes -->
        @for (designType of nestedFilterItems(); track $index) {
          <li class="filters">
            <pwj-checkbox
              [label]="designType.name"
              [isChecked]="currentFilters?.[designType.filterQueryName]"
              #colorCategoryFilter></pwj-checkbox>

            @if (colorCategoryFilter.checked) {
              <ul
                class="nested-filters"
                [formGroupName]="designType.filterQueryName">
                @for (designColor of designType.items; track $index) {
                  <li class="nested-filters__item">
                    <pwj-checkbox
                      [label]="
                        !!filterPrefix
                          ? filterPrefix + designColor
                          : designColor
                      "
                      [formControlName]="designColor"
                      (input)="setFiltersInParams()"></pwj-checkbox>
                  </li>
                }
              </ul>
            }
          </li>
        }
      </ul>
    </form>
  }
</div>
